import {isValidEmail} from "./common.js";

/**
 * Returns a function that runs a value over a provided list of validator functions.
 *
 * @param  {...function} validators
 */
// @ts-expect-error FIXME
const composeValidators = (...validators) => {
	// @ts-expect-error FIXME
	return (value, ...args) => {
		const result = validators.reduce((error, validator) => {
			// If no error is found, run the next validator and return the result
			if (!error)
				return validator(value, ...args);

			return error;
		}, undefined);

		// if the result is undefined, means there are no errors and all validators were passed
		return result;
	};
};

/**
 * Creates a validor for the given template of validators
 *
 * A validor can be a simple validation function or an array of validators.
 *
 * e.g.
 * {
 *    fieldName: value => (value ? undefined : 'fieldName is required'),
 * }
 * Or
 * {
 *    fieldName: [
 *       value => (value ? undefined : 'fieldName is required'),
 *       value => (value && value.length < 4 && 'Min length is 4') || undefined
 *    ]
 * }
 *
 * @param {object} fields validator defintion
 */
// @ts-expect-error FIXME
export const createValidator = fields => {
	// @ts-expect-error FIXME
	return values => {
		const errors = Object.keys(fields).reduce((c, k) => {
			if (!fields[k])
				return c;

			const validators = fields[k];
			const result = validate(values[k], validators, values);

			if (result !== undefined)
				return {...c, [k]: result};

			return c;
		}, {});

		const isValid = Object.keys(errors).length === 0;

		return {isValid, errors};
	};
};

// @ts-expect-error FIXME
export const validate = (value, validator, ...args) => {
	let validators = validator;

	if (typeof validator === "function")
		validators = [validators];

	const result = composeValidators(...validators)(value, ...args);

	return result;
};

export const emailValidators = [
	// @ts-expect-error FIXME
	value => value?.length ? undefined : "Required",
	// @ts-expect-error FIXME
	value => isValidEmail(value) ? undefined : `"${value}" is not a valid email address`
];

// @ts-expect-error FIXME
export const passwordValidators = (value) => {
	const length = value?.length;
	if (length === 0)
		return "Required";
	else if (length < 10)
		return "Minimum length: 10";
	else if (length > 64)
		return "Maximum length: 64";

	return undefined;
};
